import React from "react";
import { Card, Typography } from "antd";

const TermsPage = () => (
  <div className="policy-container">
    <Card>
      <Typography.Title level={2}>Terms & Conditions</Typography.Title>

      <Typography.Paragraph>
        Effective Date: <strong>November 15, 2025</strong>
      </Typography.Paragraph>

      <Typography.Paragraph>
        Welcome to Finllie. By using our website and mobile application,
        you agree to the following Terms & Conditions. Please read them
        carefully before placing an order.
      </Typography.Paragraph>

      <Typography.Title level={4}>1. About Us</Typography.Title>
      <Typography.Paragraph>
        Finllie India Pvt. Ltd<br />
        No 44, 45, 46, Silicon Town Main Road Doddanagamangala,
        Electronic City Phase 2 Bengaluru Karnataka 560100 India<br />
        Email: finlliesales@gmail.com<br />
        Phone: +91 9945089397
      </Typography.Paragraph>

      <Typography.Title level={4}>2. Orders & Acceptance</Typography.Title>
      <Typography.Paragraph>
        Placing an order on Finllie is an offer to purchase. We confirm
        acceptance by email/SMS and begin processing your order. We may
        refuse orders due to stock issues, pricing issues, or fraud.
      </Typography.Paragraph>

      <Typography.Title level={4}>3. Pricing & Taxes</Typography.Title>
      <Typography.Paragraph>
        All prices are listed in INR. GST and other charges may apply.
      </Typography.Paragraph>

      <Typography.Title level={4}>4. Payments</Typography.Title>
      <Typography.Paragraph>
        We support UPI, cards, net banking, wallets and Cash on Delivery.
        Payments are processed through secure third-party gateways.
      </Typography.Paragraph>

      <Typography.Title level={4}>5. Shipping</Typography.Title>
      <Typography.Paragraph>
        Delivery timelines may vary by location. For full details, see our
        Shipping Policy.
      </Typography.Paragraph>

      <Typography.Title level={4}>6. Returns & Refunds</Typography.Title>
      <Typography.Paragraph>
        Returns are accepted within 7 days. Refund timelines depend on your
        payment method. See our Refund Policy page.
      </Typography.Paragraph>

      <Typography.Title level={4}>7. Limitation of Liability</Typography.Title>
      <Typography.Paragraph>
        Our liability is limited to the purchase amount. We are not
        responsible for indirect damages.
      </Typography.Paragraph>

      <Typography.Title level={4}>8. Governing Law</Typography.Title>
      <Typography.Paragraph>
        All disputes fall under Karnataka jurisdiction.
      </Typography.Paragraph>
    </Card>
  </div>
);

export default TermsPage;
